import { connect } from 'react-redux';
import noop from 'lodash/noop';
import ProfileRankings from './ProfileRankings';

export const mapDispatchToProps = dispatch => ({
  onCreateClick: () =>
    dispatch({ type: 'CREATE_RANKING_VISIBLE', payload: true })
});

export default connect(noop(), mapDispatchToProps)(ProfileRankings);
